/// <reference types="vite-plugin-svgr/client" />
import VisaSvg from './visa2.svg?react';
import MastercardSvg from './mastercard.svg?react';
import AmExSvg from './americanexpress.svg?react';
import React from 'react';

export function VisaIcon(props: React.SVGProps<SVGSVGElement>) {
  return <VisaSvg {...props} />;
}

export function MastercardIcon(props: React.SVGProps<SVGSVGElement>) {
  return <MastercardSvg {...props} />;
}

export function AmExIcon(props: React.SVGProps<SVGSVGElement>) {
  return <AmExSvg fill="rgb(47,109,200)" {...props} />;
}
